
<script>
import { Line } from "vue-chartjs";
export default {
  extends: Line,
  data: () => ({
    chartData: {
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      datasets: [
        {
          label: "Cell Funds Sales",
          backgroundColor: "#8062d8",
          data: [40, 30, 5, 22, 50, 20, 11, 22, 66, 22, 33, 32],
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
    },
  }),
  methods: {},
  mounted() {
    this.renderChart(this.chartData, this.options);

    let that = this;
    Event.$on("graphs", (data) => {
      console.log(data, that.chartData.datasets[0].data);
      that.chartData.datasets[0].data = [];
      // console.log(data);
      for (let i = 0; i < 12; i++) {
        that.chartData.datasets[0].data.push(Math.random() * 100);
      }
      that.renderChart(that.chartData, that.options);
    });
  },
};
</script>


<style scoped>
</style>
